import React, { useState, useEffect } from 'react'

import { useModal } from '../../../providers/ModalProvider/ModalProvider'

import { useOrderActions } from '../../../utilities/hooks/useOrderActions'

import { ticketExchangeGetEvents } from '../../../utilities/api'

import { formatEventStart, timezones } from '../../../utilities/helpers'

import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Image from 'react-bootstrap/Image'
import Modal from 'react-bootstrap/Modal'
import Stack from 'react-bootstrap/Stack'

import { Error } from '../Error'
import { Spinner } from '../../LoadingContainer/Spinner'
import ExchangeModal from '../../TicketExchangeWrapper/ExchangeModal'

import placeholder from '../../../assets/placeholder.png'

export default function SelectEvent({ order, selectedTickets, event }) {
  const { closeModal, openModal } = useModal()

  const [orgEvents, setOrgEvents] = useState([])

  const [isLoadingEvents, setIsLoadingEvents] = useState(true)

  const [selected, setSelected] = useState()

  const [show, setShow] = useState(false)

  const [error, setError] = useState(false)

  const orderActions = useOrderActions()

  useEffect(() => {
    getEvents()
  }, [])

  const getEvents = () => {
    ticketExchangeGetEvents(order?.organizationUUID)
      .then((res) => {
        setOrgEvents(res.data)
        setIsLoadingEvents(false)
      })
      .catch((err) => {
        console.error(err)
        setError(true)
        setIsLoadingEvents(false)
      })
  }

  const handleOpenMap = () => {
    const destination = orgEvents.find((item) => item.uuid === selected)
    if (!destination || destination.soldOut) return

    openModal(
      ExchangeModal,
      {
        fromOrder: order,
        selectedEvent: selected,
        fromEvent: event,
        fromTickets: selectedTickets,
      },
      { fullscreen: true },
      { id: 'exchange-map-modal' }
    )
  }

  if (isLoadingEvents) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '200px' }}
      >
        <div className="text-center">
          <Spinner variant="dark" size="lg">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <div className="mt-3">Loading events...</div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div style={{ paddingTop: 32 }}>
        <Error
          title="Error loading events!"
          description={null}
          onClose={closeModal}
        />
      </div>
    )
  }

  return (
    <>
      <Modal.Header closeButton className="border-0 pb-0 mb-4">
        <Modal.Title className="h4 text-dark">Exchange tickets</Modal.Title>
      </Modal.Header>
      <div className="header pt-0 mb-2">
        <h2 className="normal">
          Select the game you want to exchange tickets to
        </h2>
      </div>
      <Modal.Body className="pb-0">
        <Stack gap={2} as="ul">
          {orgEvents?.map((event) => {
            const isSoldOut = event?.soldOut === true

            return (
              <li
                key={event.uuid}
                className={`list-item list-item-lg ${
                  isSoldOut ? '' : 'list-item--hover-primary'
                } ${selected == event.uuid ? 'selected' : ''}`}
              >
                <Form.Check
                  type="radio"
                  className="form-check-display m-0"
                  id={`event-display-checkbox-${event.uuid}`}
                >
                  <Form.Check.Input
                    type="radio"
                    name="event"
                    value={event.uuid}
                    className="flex-shrink-0"
                    checked={selected == event.uuid}
                    disabled={isSoldOut}
                    onChange={(e) => {
                      if (isSoldOut) return
                      setSelected(e.target.value)
                    }}
                  />
                  <Stack direction="horizontal" gap={3} className="flex-grow-1">
                    <Form.Check.Label
                      id={`event-display-checkbox-${event.uuid}`}
                      className={`m-0 d-flex gap-3 w-100 h-100 align-items-center ${
                        isSoldOut ? 'pe-none' : ''
                      }`}
                    >
                      <Image
                        src={event.image?.url || placeholder}
                        alt={`Cover art for ${event.name} event`}
                        width="64"
                        height="64"
                        className="event-image card-img-xs"
                      />
                      <Stack
                        gap={1}
                        className="justify-content-center flex-grow-1 min-w-0"
                      >
                        <h5 className="normal m-0">{event?.name}</h5>
                        <p className="text-muted small small-bold mb-0">
                          <span>
                            {formatEventStart(
                              event,
                              timezones(event?.venue?.timezone)
                            )}
                          </span>
                        </p>
                      </Stack>
                      {isSoldOut && (
                        <Badge
                          bg="none"
                          className="badge badge-sm badge--soldout w-max-content flex-shrink-0 align-self-center ms-auto"
                        >
                          Sold out
                        </Badge>
                      )}
                    </Form.Check.Label>
                  </Stack>
                </Form.Check>
              </li>
            )
          })}
        </Stack>
      </Modal.Body>

      <Modal.Footer className="border-0 btn-group-flex">
        <Button
          className="btn-back"
          variant="outline-light"
          onClick={() => orderActions.openViewProfile(order)}
        >
          Back
        </Button>
        <Button disabled={!selected} onClick={handleOpenMap}>
          Continue to map
        </Button>
      </Modal.Footer>
    </>
  )
}
